import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_alert.svg';
import Icon, { IconProps } from './icon';

const IconAlert = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconAlert;
